import {Vector2} from 'three'

export default class MouseMng {
  originalPos: Vector2
  mousemoveFuncs: Array<() => void>
  pos: {target: Vector2; current: Vector2; current2: Vector2}
  targetElementPos: Vector2
  targetElementSize: Vector2
  isMousemove: boolean = false

  constructor(targetElementPos: Vector2, targetElementSize: Vector2) {
    this.targetElementPos = targetElementPos
    this.targetElementSize = targetElementSize
    this.originalPos = new Vector2()

    this.mousemoveFuncs = []
    this.pos = {
      target: new Vector2(0, 0),
      current: new Vector2(0, 0),
      current2: new Vector2(0, 0),
    }
  }

  onMousemove(event: MouseEvent) {
    this.isMousemove = true
    let x = (event.clientX - this.targetElementPos.x) / this.targetElementSize.x
    x = (x - 0.5) * 2.0
    let y = (event.clientY - this.targetElementPos.y) / this.targetElementSize.y
    y = (0.5 - y) * 2.0

    this.updateMousePos(x, y)
  }

  onTouchstart(event: TouchEvent) {
    this.isMousemove = true
    if (event.touches[0]) {
      let x = (event.touches[0].clientX - this.targetElementPos.x) / this.targetElementSize.x
      x = (x - 0.5) * 2.0
      let y = (event.touches[0].clientY - this.targetElementPos.y) / this.targetElementSize.y
      y = (0.5 - y) * 2.0

      this.updateMousePos(x, y)
    }
  }

  updateMousePos(x: number, y: number) {
    this.pos.target.set(x, y)

    for (const func of this.mousemoveFuncs) {
      func()
    }
  }

  addMousemoveFunc(func: () => void) {
    this.mousemoveFuncs.push(func)
  }

  resize() {}

  update(delta: number) {
    this.pos.current.lerp(this.pos.target, Math.min(1, delta * 2.0))
    this.pos.current2.lerp(this.pos.target, Math.min(1, delta * 1.5))
  }
}
